export function urlModifier(url) {
  return url;
}
export function urlReplacer(url) {
  return url;
}
export const SOCKET_PATH = null;
export const TRANSPORTS = ['websocket'];